import React, { useEffect } from "react";
import { useHistory, Switch, Route, useLocation } from "react-router-dom";

import { getUser } from "../state/User";
import Login from "./auth/Login";
import Register from "./auth/Register";
import Dashboard from "./Dashboard";
import Loading from "./utils/Loading";
import Header from "./utils/Header";
import Center from "./utils/Center";

function Default() {
  return (
    <>
      <Header className="mb3 pt3" />
      <Center width={40}>
        <Loading />
      </Center>
    </>
  );
}

export default function App() {
  const user = getUser();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const currentLoc = location.pathname;
    if (
      user === null &&
      !currentLoc.match(/^\/register/) &&
      !currentLoc.match(/^\/login/)
    ) {
      history.push("/login");
    }
  }, [user]);

  if (typeof user === "undefined") {
    return <Default />;
  }

  if (user === null) {
    return (
      <Switch>
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/register">
          <Register />
        </Route>
      </Switch>
    );
  }

  return <Dashboard />;
}
